
export default {
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      targets: [],
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.init()
      this.targets = this.$gsap.utils.toArray('.esg-report')
    })
  },
  methods: {
    init() {
      this.$gsap.set('.esg-report', {
        yPercent: 600,
      })

      this.$gsap
        .timeline()
        .to('.esg-report-blur', {
          yPercent: -10,
          // stagger: 0.1,
          duration: 0.7,
          ease: 'back(.5)',
          // onComplete: () => {
          //   // Animate the properties individually
          //   this.$gsap.utils.toArray('.esg-report-blur').forEach((el) => {
          //     //   tweenProperty(el, 'scale', 0.94, 1)
          //     this.tweenProperty(el, 'x', -6, 6)
          //     this.tweenProperty(el, 'y', -6, 6)
          //     this.tweenProperty(el, 'rotate', -1, 1)
          //   })
          // },
        })
        .to(
          '.esg-report-no-blur',
          {
            yPercent: -10,
            stagger: 0.2,
            duration: 1,
            ease: 'back(.5)',
            onComplete: () => {
              // Animate the properties individually
              // this.$gsap.utils.toArray('.esg-report-no-blur').forEach((el) => {
              //   //   tweenProperty(el, 'scale', 0.94, 1)
              //   this.tweenProperty(el, 'x', -6, 6)
              //   this.tweenProperty(el, 'y', -6, 6)
              //   this.tweenProperty(el, 'rotate', -1, 1)
              // })

              this.$parent.$parent.$el.addEventListener(
                'mousemove',
                this.mouseMoveFunc
              )

              // this.$gsap
              //   .timeline({
              //     scrollTrigger: {
              //       trigger: this.$refs.reportsContainer,
              //       scrub: true,
              //       // markers: true,
              //     },
              //   })
              //   .to(
              //     '.esg-report-no-blur',
              //     // {
              //     //   yPercent: -10,
              //     // },
              //     {
              //       zIndex: 60,
              //       // scale: 4,
              //       transformOrigin: '30% center',
              //       xPercent: -200,
              //     }
              //   )
            },
          },
          '<'
        )
    },
    mouseMoveFunc(e) {
      this.targets.forEach((target, index) => {
        const depth = 95
        const moveX = (e.pageX - window.innerWidth / 2) / depth
        const moveY = (e.pageY - window.innerHeight / 2) / depth
        index++

        this.$gsap.to(target, {
          x: moveX * index,
          y: moveY * index,
        })
      })
    },
    // tweenProperty(target, prop, min, max) {
    //   const randomDur = this.$gsap.utils.random(3, 6, 0.2, true)
    //   const randomDelay = this.$gsap.utils.random(0.6, 2, 0.2, true)

    //   this.$gsap.to(target, {
    //     [prop]: this.$gsap.utils.random(min, max),
    //     duration: randomDur(),
    //     delay: randomDelay(),
    //     ease: 'none',
    //     onComplete: this.tweenProperty,
    //     onCompleteParams: [target, prop, min, max],
    //   })
    // },
  },
}
